import LocalizedStrings from 'react-localization'

export const strings = new LocalizedStrings({
  en: {
    nameLabel: 'Name',
  },
})
